<template>
  <b-row>
    <b-col>
      <b-table :fields="fields"
               :items="[{...proposalFromValue, _showDetails: true}]"
               class="table-responsive"
               head-variant="light"
               responsive
               striped>
        <template v-slot:cell(actions)="row">
          <action-download-pdf :proposal="row.item.proposal"/>
        </template>
        <template v-slot:row-details>
          <b-table :fields="modalDetailsFields"
                   :items="[proposalFromValue]"
                   class="table-responsive"
                   stacked
                   bordered
                   small
                   hover
                   responsive>
          </b-table>
        </template>
      </b-table>

      <review_form v-model="proposalFromValue"
                   :shifts_config="shifts_config"
                   @close-modal="closeModalEmit">
      </review_form>
    </b-col>
    <b-col>
      <evaluations-summary-table :value="proposalFromValue.proposal"/>
    </b-col>
  </b-row>
</template>

<script>
  import ActionDownloadPdf from '@/components/actions/ActionDownloadPdf';
  import EvaluationsSummaryTable from '@/components/evaluation/EvaluationsSummaryTable';
  // eslint-disable-next-line camelcase
  import review_form from '@/components/evaluation/review/review_form';

  export default {
    name: 'review_modal',
    components: {
      ActionDownloadPdf,
      EvaluationsSummaryTable,
      // eslint-disable-next-line camelcase
      review_form,
    },
    props: {
      fields: {
        type: Array,
        default: () => [],
      },
      modalDetailsFields: {
        type: Array,
        default: () => [],
      },
      // eslint-disable-next-line camelcase
      shifts_config: {
        type: Array,
        default: () => [],
      },
      value: {
        type: Object,
        required: true,
      },
    },
    data() {
      return { proposalFromValue: this.value };
    },
    watch: {
      proposalFromValue: {
        handler() {
          this.$emit('input', this.proposalFromValue);
        },
        deep: true,
      },
      value() {
        this.proposalFromValue = this.value;
      },
    },
  };
</script>

<style scoped>

</style>
